import { components, OptionProps } from 'react-select';
import { FormSingleSelectFieldProps, WrappedFormSingleSelectField } from './FormSingleSelectField';
import RedX from 'assets/ibanera/Icon_RedCross.png';
import { SelectOption } from './Dropdown';

type Props<T> = {
    onDeleteItem(value: SelectOption): void;
} & FormSingleSelectFieldProps<T>;

export const SingleSelectRemoveOption = <T,>({
    onDeleteItem,
    dropdownProps,
    ...props
}: Props<T>) => {
    const handleDelete = (event: React.MouseEvent<HTMLElement>, value: any) => {
        event.stopPropagation();

        onDeleteItem(value);
    };

    const Option = (props: OptionProps<any, false>) => (
        <div>
            <components.Option
                {...props}
                className={`RemoveOptionContainer ${props.className ?? ''}`}
            >
                <div className="OptionTextContainer">
                    <span className="OptionLabel">{props.data.label}</span>
                    {props.data.subtitle && <p className="OptionSubtitle">{props.data.subtitle}</p>}
                </div>
                <div
                    onClick={(e) => handleDelete(e, props.data)}
                    className="RemoveOptionContainerImage"
                >
                    <img src={RedX} alt="Delete" />
                </div>
            </components.Option>
        </div>
    );

    const SingleValue = (props: OptionProps<any, false>) => (
        <div className="OptionTextContainer">
            <span className="OptionSubtitle">
                {props.data.label} {props.data.subtitle && <span>({props.data.subtitle})</span>}
            </span>
        </div>
    );
    return (
        <WrappedFormSingleSelectField
            dropdownProps={{
                components: {
                    Option,
                    SingleValue,
                },
                ...dropdownProps,
            }}
            {...props}
        />
    );
};
